export default {
	"exchange.CannotExceed20Characters": "Cannot exceed 20 characters",
	"exchange.PleaseEnterTheRedemptionCode": "Please enter the redemption code",
	"exchange.TheRedemptionCodeIsNotLegitimate": "The redemption code is not legitimate",
	"exchange.PleaseEnterTheActivationCodeToRedeemTheProduct": "Please enter the activation code to redeem the product",
	"exchange.RedeemNow": "Redeem now",
	"exchange.TheRedemptionCodeIsAContentRedemptionVoucherObtainedFromAThirdParty": "The redemption code is a content redemption voucher obtained from a third party,",
	"exchange.CanBeRedeemedForTheCorrespondingGoods": "Can be redeemed for the corresponding goods",
	"exchange.IfYouHaveAnyQuestionsPleaseContactCustomerService": "If you have any questions, please contact customer service >"
}